import { render, staticRenderFns } from "./PillNavigation.vue?vue&type=template&id=7aa347e8&scoped=true"
import script from "./PillNavigation.vue?vue&type=script&lang=js"
export * from "./PillNavigation.vue?vue&type=script&lang=js"
import style0 from "./PillNavigation.vue?vue&type=style&index=0&id=7aa347e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa347e8",
  null
  
)

export default component.exports